module.exports = __webpack_public_path__ + "assets/images/novasport_2.0bf63f8c8af90dc524ac9d60d13cfa6b.png";